<template>
  <spr-dialog name="company" :show="show" title="公司信息" @confirm="handleConfirm" @open="handleOpen" @update:show="(flag) => this.$emit('update:show', flag)">
    <el-form ref="form" :inline="true" :model="Form" label-suffix="：" label-width="110px" style="margin: 0 20px;" :rules="Rules">
        <el-form-item label="公司名称" prop="CardName">
          <el-input v-model="Form.CardName" style="width: 280px; margin-right: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="Address">
          <spr-address
            :province-id.sync="Form.ProvinceCode"
            :city-id.sync="Form.CityCode"
            :county-id.sync="Form.AreaCode"
            :address.sync="Form.Address"></spr-address>
        </el-form-item>
        <el-form-item label="联系电话" prop="Phone">
          <el-input style="width: 350px" v-model="Form.Phone"></el-input>
        </el-form-item>
        <el-form-item label="公司邮箱" prop="Email">
          <el-input style="width: 350px" v-model="Form.Email"></el-input>
        </el-form-item>
        <el-form-item label="公司QQ" prop="QQ">
          <el-input style="width: 350px" v-model="Form.QQ"></el-input>
        </el-form-item>
        <el-form-item label="公司微信" prop="WeChat">
          <el-input style="width: 350px" v-model="Form.WeChat"></el-input>
        </el-form-item>
        <el-form-item label="公司传真" prop="Fax">
          <el-input style="width: 350px" v-model="Form.Fax"></el-input>
        </el-form-item>
        <el-form-item label="公司开票代码" prop="InvoiceCode">
          <el-input style="width: 350px" v-model="Form.InvoiceCode"></el-input>
        </el-form-item>
        <el-form-item label="公司网站" prop="CardUrl">
          <el-input style="width: 824px" v-model="Form.CardUrl"></el-input>
        </el-form-item>
      </el-form>
  </spr-dialog>
</template>

<script>
import SprDialog from './Dialog'
import SprAddress from '@/components/common/Address'

export default {
  data() {
    return {
      Form: {},
      Rules: {
        CardName: [{required: true, message: '该字段必填', trigger: 'blur'}],
        Address: [{required: true, message: '该字段必填', trigger: 'blur'}],
        Phone: [
          {required: true, message: '该字段必填', trigger: 'blur'},
          {pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/, message: '手机号格式错误'},
        ],
        Email: [
          {required: true, message: '该字段必填', trigger: 'blur'},
          {type: 'email', message: '邮箱格式错误'},
        ],
        QQ: [
          {pattern: /^\d+$/, message: 'QQ必须为数字'},
          {pattern: /^\d{0,14}$/, message: 'QQ号最大14位'},
        ],
        InvoiceCode: [
          {pattern: /^[a-z0-9]{18}$/, message: '请输入18位开票代码'},
        ],
      },
    }
  },
  props: {
    form: Object,
    show: Boolean,
  },
  methods: {
    handleOpen() {
      this.$set(this, 'Form', {
        Code: this.form.CardCode,
        CardName: this.form.CardName,
        ProvinceCode: this.form.ProvinceCode,
        CityCode: this.form.CityCode,
        AreaCode: this.form.AreaCode,
        Address: this.form.Address,
        Phone: this.form.Phone,
        Email: this.form.Email,
        QQ: this.form.QQ,
        WeChat: this.form.WeChat,
        Fax: this.form.Fax,
        InvoiceCode: this.form.InvoiceCode,
        CardUrl: this.form.CardUrl,
      })
    },
    handleConfirm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('confirm', this.Form)
        }
      })
    },
  },
  components: {
    SprDialog,
    SprAddress,
  },
}
</script>

<style lang="less">
.work-place.address-box {
  display: block;
  width: auto !important;
  .el-col {
    width: auto;
    margin-right: 6px;
    &:nth-child(3), &:nth-child(4) {
      margin-right: 0;
    }
  }
  .province, .city, .county {
    width: 126px;
  }
  .address {
    width: 390px;
    margin-top: 6px;
  }
}
.inner-form {
  // margin-left: 67px;
  .el-form-item {
    margin: 0;
    .el-form-item__content {
      min-width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// CompanyDialog.vue?822b12a6